import { HelpBoxSize, IconType, textBox } from "../Help/View.fs.js";
import { Msg, Page } from "./Types.fs.js";
import { value as value_2, defaultArg } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { Tab_Option, tab, Option, tabs } from "../../../fable_modules/Fulma.3.0.0/Components/Tabs.fs.js";
import { isEmpty, contains, ofArray, singleton } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { equalsWith, append as append_1, reverse, mapIndexed, item, sumBy, tryFind, sortBy, map } from "../../../fable_modules/fable-library-js.4.19.0/Array.js";
import * as react from "react";
import { defaultOf, equals, comparePrimitives, stringHash, compareArrays } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { DropdownProps$1, bfsDropdown } from "../Shared/Dropdown.fs.js";
import { errorMsg, spinner, Icons_TicketErstellenLink, linkicon, Icons_TicketLink, disabeldCheckboxWithTooltipMultiline, orangeCheckbox } from "../../../../Bfs.Web.Portale/ViewParts.fs.js";
import { GlobalMsg, GlobalMessageBox_Error_Z721C83C5 } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { asMoneySpan } from "../../../../Bfs.Web.Portale/Helpers.fs.js";
import { compare, year, month, toString } from "../../../fable_modules/fable-library-js.4.19.0/Date.js";
import { HTMLAttr, DangerousHtml, DOMAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { CollapsableElement } from "../../../../Bfs.Web.Portale/Collapsable.fs.js";
import { op_Addition } from "../../../fable_modules/fable-library-js.4.19.0/Decimal.js";
import Decimal from "../../../fable_modules/fable-library-js.4.19.0/Decimal.js";
import { asString, asHtmlMoney, monatName } from "../../../../Bfs.Web.Data.Service.Contracts/Shared.fs.js";
import { Option as Option_1, columns } from "../../../fable_modules/Fulma.3.0.0/Layouts/Columns.fs.js";
import { Array_groupBy } from "../../../fable_modules/fable-library-js.4.19.0/Seq2.js";
import { Filter } from "../../../Kundenportal.Types.fs.js";
import { Page as Page_1 } from "../Files/Types.fs.js";
import { userDialog } from "../Shared/Modal.fs.js";
import { Page as Page_2 } from "../Tickets/Types.fs.js";

function verrechnungenBox(size, navigateTo) {
    return textBox(size, "Anstehende Verrechnungen", "bfs_verrechnung", new IconType(2, []), "Hier finden Sie eine Übersicht über Ihre anstehenden Verrechnungen.", undefined)((_arg) => {
        navigateTo(new Page(undefined));
    });
}

export const wideVerrechnungenBox = (navigateTo) => verrechnungenBox(new HelpBoxSize(1, []), navigateTo);

export function filialenRow(selectedFilialeId, dispatch, filialen) {
    const selectedFilialeId_1 = defaultArg(selectedFilialeId, "00000000-0000-0000-0000-000000000000");
    return tabs(singleton(new Option(7, ["is-hidden-touch account-tabs main-menu with-width-constraint"])), [map((f_1) => tab(ofArray([new Tab_Option(1, ["submenu-item"]), new Tab_Option(0, [f_1.FilialeId === selectedFilialeId_1])]), singleton(react.createElement("a", {
        onClick: (_arg) => {
            dispatch(new Msg(14, [f_1.FilialeId]));
        },
    }, f_1.Name))), sortBy((f) => [!f.IsZentrale, f.Name], filialen, {
        Compare: compareArrays,
    }))]);
}

export function filialenMobile(selectedFilialeId, dispatch, filialen) {
    const children = [bfsDropdown()(new DropdownProps$1(ofArray(sortBy((f) => [!f.IsZentrale, f.Name], filialen, {
        Compare: compareArrays,
    })), tryFind((filiale_1) => {
        if (selectedFilialeId != null) {
            return filiale_1.FilialeId === value_2(selectedFilialeId);
        }
        else {
            return false;
        }
    }, filialen), (_arg_1) => _arg_1.Name, (_arg) => _arg.FilialeId, (filiale) => {
        dispatch(new Msg(14, [filiale.FilialeId]));
    }))];
    return react.createElement("div", {
        className: "is-hidden-desktop mb-2",
    }, ...children);
}

export function verrechnungNichtMoeglichText(verrechnung) {
    const matchValue = verrechnung.Status | 0;
    switch (matchValue) {
        case 2:
            return "Diese Forderung ist für die Verrechnung bereits unveränderbar terminiert und kann daher nicht verschoben werden.";
        case 3:
            return "Diese Forderung ist bereits fällig und kann daher nicht verschoben werden.";
        case 4:
            return "Die Fälligkeit dieser Forderung wurde bereits einmal verschoben und kann daher nicht erneut verschoben werden.";
        default:
            return "";
    }
}

export function verrechnungCheckbox(verrechnung, isSelected, dispatch) {
    if (verrechnung.Status === 1) {
        return orangeCheckbox(isSelected, (_arg) => {
            dispatch(new Msg(13, [verrechnung.ForderungId, !isSelected]));
        });
    }
    else {
        const text = verrechnungNichtMoeglichText(verrechnung);
        const children = [disabeldCheckboxWithTooltipMultiline(text, (_arg_1) => {
            dispatch(new Msg(18, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5(text)])]));
        })];
        return react.createElement("div", {
            className: "is-hidden-touch",
        }, ...children);
    }
}

export function ticketText(verrechnung) {
    return toText(printf("Anstehende Verrechnung zur Rechnung %s"))(verrechnung.RechnugnsNr);
}

export function verrechnugnenMobile(verrechnungen, model, dispatch, navigateTo, withCheckboxes) {
    const children_29 = [map((v) => {
        let children_5, children_3, children_25;
        const isExpanded = contains(v.ForderungId, model.ExpandedVerrechnungen, {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        });
        const iconclass = isExpanded ? " upsidedown" : "";
        const active = isExpanded ? " is-active" : "";
        const isSelected = contains(v.ForderungId, model.SelectedVerrechnugen, {
            Equals: (x_1, y_1) => (x_1 === y_1),
            GetHashCode: stringHash,
        });
        let expandedText;
        const children_2 = [react.createElement("p", {}, v.Details), Icons_TicketLink("Tickets", (e) => {
            e.stopPropagation();
            dispatch(new Msg(17, [v]));
        })];
        expandedText = react.createElement(react.Fragment, {}, ...children_2);
        const children_27 = [(children_5 = [(children_3 = toList(delay(() => append(withCheckboxes ? singleton_1(verrechnungCheckbox(v, isSelected, dispatch)) : empty(), delay(() => singleton_1(toText(printf("Rechnung %s (%s, %s)"))(v.RechnugnsNr)(v.KlientNachname)(v.KlientVorname)))))), react.createElement("div", {
            className: "dta-file",
        }, ...children_3))], react.createElement("div", {}, ...children_5)), (children_25 = toList(delay(() => {
            let children_7;
            return append(withCheckboxes ? singleton_1((children_7 = [verrechnungNichtMoeglichText(v)], react.createElement("div", {
                className: "has-text-danger mb-2",
            }, ...children_7))) : empty(), delay(() => {
                let children_11, children_9, arg_3;
                return append(singleton_1((children_11 = [(children_9 = [asMoneySpan(v.Betrag), " Kürzung von ", asMoneySpan(v.Rechnungsbetrag), " Rechnungsbetrag ", (arg_3 = toString(v.Faelligkeitsdatum, "dd.MM.yyyy"), toText(printf("am %s"))(arg_3)), " Ankaufdatum ", toString(v.Ankaufdatum, "dd.MM.yyyy")], react.createElement("span", {}, ...children_9))], react.createElement("div", {}, ...children_11))), delay(() => {
                    let props_21, children_21, props_19, children_19, children_17, children_15;
                    return append(singleton_1((props_21 = [["style", {
                        marginTop: "10px",
                    }], new DOMAttr(40, [(_arg) => {
                        dispatch(new Msg(16, [v.ForderungId]));
                    }])], (children_21 = [(props_19 = [["style", {
                        display: "flex",
                    }]], (children_19 = [react.createElement("div", {}, v.Absetzungsgrund), (children_17 = [(children_15 = [linkicon("fas fa-chevron-down" + iconclass)], react.createElement("a", {}, ...children_15))], react.createElement("div", {}, ...children_17))], react.createElement("div", keyValueList(props_19, 1), ...children_19)))], react.createElement("div", keyValueList(props_21, 1), ...children_21)))), delay(() => {
                        let children_23;
                        return singleton_1((children_23 = [CollapsableElement([expandedText, isExpanded])], react.createElement("div", {
                            className: "beschreibung",
                        }, ...children_23)));
                    }));
                }));
            }));
        })), react.createElement("div", {
            className: "dta-status",
        }, ...children_25))];
        return react.createElement("div", {
            className: "data-item",
        }, ...children_27);
    }, verrechnungen)];
    return react.createElement("div", {
        className: "data-list is-hidden-desktop",
    }, ...children_29);
}

export function verrechnungZeile(dispatch, navigateTo, model, withCheckboxes, verrechnung) {
    const isExpanded = contains(verrechnung.ForderungId, model.ExpandedVerrechnungen, {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    });
    const iconclass = isExpanded ? " upsidedown" : "";
    const isSelected = contains(verrechnung.ForderungId, model.SelectedVerrechnugen, {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: stringHash,
    });
    let expandedText;
    const children_2 = [react.createElement("p", {}, verrechnung.Details), Icons_TicketLink("Tickets", (e) => {
        e.stopPropagation();
        dispatch(new Msg(17, [verrechnung]));
    })];
    expandedText = react.createElement(react.Fragment, {}, ...children_2);
    const children_29 = toList(delay(() => {
        let children_3;
        return append(withCheckboxes ? singleton_1((children_3 = [verrechnungCheckbox(verrechnung, isSelected, dispatch)], react.createElement("td", {}, ...children_3))) : empty(), delay(() => {
            let props_9, children_9, children_7;
            return append(singleton_1((props_9 = [["style", {
                width: "15%",
                minWidth: "180px",
            }]], (children_9 = [react.createElement("p", {}, verrechnung.RechnugnsNr), (children_7 = [toText(printf("%s, %s"))(verrechnung.KlientNachname)(verrechnung.KlientVorname)], react.createElement("p", {}, ...children_7))], react.createElement("td", keyValueList(props_9, 1), ...children_9)))), delay(() => {
                let children_11;
                return append(singleton_1((children_11 = [toString(verrechnung.Ankaufdatum, "dd.MM.yyyy")], react.createElement("td", {}, ...children_11))), delay(() => {
                    let children_13;
                    return append(singleton_1((children_13 = [toString(verrechnung.Faelligkeitsdatum, "dd.MM.yyyy")], react.createElement("td", {}, ...children_13))), delay(() => {
                        let children_19, children_17;
                        return append(singleton_1((children_19 = [react.createElement("div", {}, verrechnung.Absetzungsgrund), (children_17 = [CollapsableElement([expandedText, isExpanded])], react.createElement("div", {
                            className: "beschreibung",
                        }, ...children_17))], react.createElement("td", {
                            onClick: (_arg) => {
                                dispatch(new Msg(16, [verrechnung.ForderungId]));
                            },
                        }, ...children_19))), delay(() => {
                            let children_21;
                            return append(singleton_1((children_21 = [asMoneySpan(verrechnung.Rechnungsbetrag)], react.createElement("td", {
                                className: "text-right",
                            }, ...children_21))), delay(() => {
                                let children_23;
                                return append(singleton_1((children_23 = [asMoneySpan(verrechnung.Betrag)], react.createElement("td", {
                                    className: "text-right",
                                }, ...children_23))), delay(() => {
                                    let children_27, children_25;
                                    return singleton_1((children_27 = [(children_25 = [linkicon("fas fa-chevron-down" + iconclass)], react.createElement("a", {}, ...children_25))], react.createElement("td", {
                                        onClick: (_arg_1) => {
                                            dispatch(new Msg(16, [verrechnung.ForderungId]));
                                        },
                                    }, ...children_27)));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    }));
    return react.createElement("tr", {}, ...children_29);
}

export function verrechnugnenTabelle(verrechnungen, model, dispatch, navigateTo, withCheckboxes) {
    let children_18, children_16, children_20;
    const children_22 = [(children_18 = [(children_16 = toList(delay(() => append(withCheckboxes ? singleton_1(react.createElement("th", {})) : empty(), delay(() => append(singleton_1(react.createElement("th", {}, "Rechnung")), delay(() => append(singleton_1(react.createElement("th", {}, "Ankaufdatum")), delay(() => append(singleton_1(react.createElement("th", {}, "Verrechnung am")), delay(() => {
        let props_8;
        return append(singleton_1((props_8 = [new DOMAttr(0, [new DangerousHtml("Absetzungs&shy;grund")])], react.createElement("th", keyValueList(props_8, 1)))), delay(() => {
            let props_10;
            return append(singleton_1((props_10 = [new HTMLAttr(65, ["text-right"]), new DOMAttr(0, [new DangerousHtml("Rechnungs&shy;betrag")])], react.createElement("th", keyValueList(props_10, 1)))), delay(() => {
                let props_12;
                return append(singleton_1((props_12 = [new HTMLAttr(65, ["text-right"]), new DOMAttr(0, [new DangerousHtml("Kürzungs&shy;summe")])], react.createElement("th", keyValueList(props_12, 1)))), delay(() => singleton_1(react.createElement("th", {}))));
            }));
        }));
    })))))))))), react.createElement("tr", {}, ...children_16))], react.createElement("thead", {}, ...children_18)), (children_20 = map((verrechnung) => verrechnungZeile(dispatch, navigateTo, model, withCheckboxes, verrechnung), verrechnungen), react.createElement("tbody", {}, ...children_20))];
    return react.createElement("table", {
        className: "table table-striped responsive-table is-hidden-touch",
    }, ...children_22);
}

export const emptyBox = (() => {
    let children_12, children_10, children_4, children_2, children_8, children_6, s_1;
    const children_14 = [(children_12 = [(children_10 = [(children_4 = [(children_2 = [react.createElement("b", {}, "Keine anstehenden Verrechnungen")], react.createElement("h3", {}, ...children_2))], react.createElement("div", {
        className: "card-title",
    }, ...children_4)), (children_8 = [(children_6 = [(s_1 = "Derzeit gibt es keine Forderungen, zu denen es ein Abrechnungsproblem gibt und die zur Verrechnung anstehen.", s_1)], react.createElement("p", {}, ...children_6))], react.createElement("div", {
        className: "card-body",
    }, ...children_8))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto overflow-initial",
    }, ...children_10))], react.createElement("div", {
        className: "column is-12",
    }, ...children_12))];
    return react.createElement("div", {
        className: "columns",
    }, ...children_14);
})();

export function monatBox(showEasterEggs, dispatch, navigateTo, verrechnungen, model) {
    let copyOfStruct, copyOfStruct_1, children_16, children_12, children_2, props, summeGewaehlt, arg, arg_1, arg_2, arg_3, arg_4, arg_5, arg_6, children_10, children_14;
    const summeKuerzungen = sumBy((v) => v.Betrag, verrechnungen, {
        GetZero: () => (new Decimal("0")),
        Add: op_Addition,
    });
    const monat = item(0, verrechnungen).Faelligkeitsdatum;
    const verschiebenMoeglich = (model.UserDarfVerschieben && model.FilialeKannVerschieben) && (model.VerrechnungAuswaehlenFuerMonat == null);
    const istAmVerscheiben = ((model.VerrechnungAuswaehlenFuerMonat != null) && (((copyOfStruct = value_2(model.VerrechnungAuswaehlenFuerMonat), month(copyOfStruct))) === month(monat))) && (((copyOfStruct_1 = value_2(model.VerrechnungAuswaehlenFuerMonat), year(copyOfStruct_1))) === year(monat));
    const children_18 = [(children_16 = [(children_12 = [(children_2 = [(props = [new DOMAttr(0, [new DangerousHtml(istAmVerscheiben ? ((summeGewaehlt = sumBy((v_2) => v_2.Betrag, verrechnungen.filter((v_1) => contains(v_1.ForderungId, model.SelectedVerrechnugen, {
        Equals: (x_1, y_1) => (x_1 === y_1),
        GetHashCode: stringHash,
    })), {
        GetZero: () => (new Decimal("0")),
        Add: op_Addition,
    }), (arg = monatName(month(monat)), (arg_1 = (year(monat) | 0), (arg_2 = asHtmlMoney(summeGewaehlt), (arg_3 = asHtmlMoney(summeKuerzungen), toText(printf("%s %i (%s von %s gewählt)"))(arg)(arg_1)(arg_2)(arg_3))))))) : ((arg_4 = monatName(month(monat)), (arg_5 = (year(monat) | 0), (arg_6 = asHtmlMoney(summeKuerzungen), toText(printf("%s %i (%s)"))(arg_4)(arg_5)(arg_6))))))])], react.createElement("b", keyValueList(props, 1)))], react.createElement("h3", {}, ...children_2)), (children_10 = toList(delay(() => append(istAmVerscheiben ? singleton_1(react.createElement("a", {
        className: "bfsbutton gray",
        onClick: (_arg) => {
            dispatch(new Msg(9, []));
        },
    }, "Abbrechen")) : empty(), delay(() => append(verschiebenMoeglich ? singleton_1(react.createElement("a", {
        className: "bfsbutton",
        onClick: (_arg_1) => {
            dispatch(new Msg(4, [monat]));
        },
    }, "Verschieben")) : empty(), delay(() => {
        let props_8;
        return istAmVerscheiben ? singleton_1((props_8 = [new HTMLAttr(65, ["bfsbutton"]), new HTMLAttr(79, [isEmpty(model.SelectedVerrechnugen)]), new DOMAttr(40, [(_arg_2) => {
            if (!isEmpty(model.SelectedVerrechnugen)) {
                dispatch(new Msg(5, []));
            }
        }])], react.createElement("a", keyValueList(props_8, 1), "Jetzt verschieben"))) : empty();
    })))))), react.createElement("div", {
        className: "headerbuttons",
    }, ...children_10))], react.createElement("div", {
        className: "card-title",
    }, ...children_12)), (children_14 = [verrechnugnenTabelle(verrechnungen, model, dispatch, navigateTo, istAmVerscheiben), verrechnugnenMobile(verrechnungen, model, dispatch, navigateTo, istAmVerscheiben)], react.createElement("div", {
        className: "card-body",
    }, ...children_14))], react.createElement("div", {
        className: "flat-card profile-info-card is-auto overflow-initial is-relative",
    }, ...children_16))];
    return react.createElement("div", {
        className: "column is-12",
    }, ...children_18);
}

export function monatBoxen(dispatch, navigateTo, verrechnugnen, model) {
    return columns(ofArray([new Option_1(8, ["verrechnungen"]), new Option_1(2, [])]), ofArray(mapIndexed((index, tupledArg_1) => monatBox(index === 0, dispatch, navigateTo, sortBy((v_1) => [v_1.Faelligkeitsdatum, v_1.Absetzungsgrund, v_1.KlientNachname, v_1.KlientVorname], tupledArg_1[1], {
        Compare: compareArrays,
    }), model), sortBy((tupledArg) => tupledArg[0], Array_groupBy((v) => {
        const arg = year(v.Faelligkeitsdatum) | 0;
        const arg_1 = month(v.Faelligkeitsdatum) | 0;
        return toText(printf("%04i-%02i"))(arg)(arg_1);
    }, verrechnugnen, {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    }), {
        Compare: comparePrimitives,
    }))));
}

export function dtaReportText(dispatch, navigateTo, model) {
    const children_4 = toList(delay(() => append(singleton_1("Diese anstehenden Verrechnungen können Sie auch der Auswertung \"Offene Absetzungen\" entnehmen. "), delay(() => (!model.DtaReportAngefordert ? append(singleton_1("Klicken Sie "), delay(() => append(singleton_1(react.createElement("a", {
        onClick: (_arg) => {
            dispatch(new Msg(10, []));
        },
    }, "hier")), delay(() => singleton_1(" um diese anzufordern."))))) : append(singleton_1("Die Auswertung wird in Kürze für Sie erzeugt und steht Ihnen unter "), delay(() => append(singleton_1(react.createElement("a", {
        onClick: (_arg_1) => {
            navigateTo(new Page_1(1, new Filter(1, [])));
        },
    }, "Dokumente")), delay(() => singleton_1(" zur Verfügung."))))))))));
    return react.createElement("div", {
        className: "verrechnungen plain-text",
    }, ...children_4);
}

export function infoBox(dispatch, navigateTo) {
    let children_14, children_12, children_2, children, s, children_6, children_4, s_1, children_10;
    const children_18 = [(children_14 = [(children_12 = [(children_2 = [react.createElement("img", {
        src: "help/bfs_epost_4.png",
    }), (children = [(s = "Um eine Verrechnung zu verhindern, reichen Sie uns bis zur ausgewiesenen Frist Ihre Unterlagen zwecks Widerspruch ein.", s)], react.createElement("p", {}, ...children))], react.createElement("div", {
        className: "column is-4",
    }, ...children_2)), (children_6 = [react.createElement("img", {
        src: "help/bfs_verrechnung_4.png",
    }), (children_4 = [(s_1 = "Jetzt neu – verschieben Sie die Frist in den nächsten Monat. Alle Informationen hierzu finden Sie auf dieser Seite.", s_1)], react.createElement("p", {}, ...children_4))], react.createElement("div", {
        className: "column is-4",
    }, ...children_6)), (children_10 = [react.createElement("img", {
        src: "help/bfs_ticketsystem_4.png",
    }), react.createElement("p", {}, "Bei weiteren Fragen nutzen Sie bitte unser Ticket System.")], react.createElement("div", {
        className: "column is-4",
    }, ...children_10))], react.createElement("div", {
        className: "columns",
    }, ...children_12))], react.createElement("div", {
        className: "container",
    }, ...children_14)), react.createElement("button", {
        onClick: (_arg) => {
            dispatch(new Msg(15, []));
        },
        className: "bfsdelete narrow",
        title: "schließen",
    })];
    return react.createElement("div", {
        className: "verrechnungen box",
    }, ...children_18);
}

export function ticketModal(verrechnung, navigateTo, dispatch) {
    let children_40, children_28, children_8, children_26, array_3, children_24, children_22, children_38, array_8, children_50, array_13;
    return userDialog(`Tickets zu Rechnung ${verrechnung.RechnugnsNr}`, ofArray([(children_40 = [(children_28 = [(children_8 = [react.createElement("th", {}, "Ticket"), react.createElement("th", {}, "Datum"), react.createElement("th", {}, "Status"), react.createElement("th", {})], react.createElement("tr", {}, ...children_8)), (children_26 = reverse((array_3 = map((ticket_1) => {
        let children_14, children_12, children_16, children_18;
        const children_20 = [react.createElement("td", {
            className: "ticket-betreff",
        }, ticket_1.Betreff), (children_14 = [(children_12 = [asString(ticket_1.Datum)], react.createElement("div", {}, ...children_12))], react.createElement("td", {
            className: "nowrap",
        }, ...children_14)), (children_16 = [ticket_1.IstErledigt ? (ticket_1.HatAntworten ? "Beantwortet" : "Erledigt") : "In Arbeit"], react.createElement("td", {
            className: "nowrap",
        }, ...children_16)), (children_18 = [Icons_TicketLink("Ticket anzeigen", (_arg) => {
            navigateTo(new Page_2(1, [ticket_1.TicketId]));
        })], react.createElement("td", {
            className: "nowrap",
        }, ...children_18))];
        return react.createElement("tr", {}, ...children_20);
    }, sortBy((ticket) => ticket.Datum, verrechnung.Tickets, {
        Compare: compare,
    })), append_1([(children_24 = [(children_22 = [Icons_TicketErstellenLink((_arg_1) => {
        navigateTo(new Page_2(3, [ticketText(verrechnung), verrechnung.RechnungId]));
    })], react.createElement("td", {
        colSpan: 4,
    }, ...children_22))], react.createElement("tr", {}, ...children_24))], array_3))), react.createElement("tbody", {}, ...children_26))], react.createElement("thead", {}, ...children_28)), (children_38 = reverse((array_8 = map((ticket_3) => {
        let children_34, children_32;
        const children_36 = [react.createElement("div", {
            className: "dta-file",
        }, ticket_3.Betreff), (children_34 = [asString(ticket_3.Datum), " - ", ticket_3.IstErledigt ? (ticket_3.HatAntworten ? "Beantwortet" : "Erledigt") : "In Arbeit", (children_32 = [Icons_TicketLink("Ticket anzeigen", (_arg_2) => {
            navigateTo(new Page_2(1, [ticket_3.TicketId]));
        })], react.createElement("span", {
            className: "go-to-ticket",
        }, ...children_32))], react.createElement("div", {
            className: "dta-status",
        }, ...children_34))];
        return react.createElement("div", {
            className: "ticket data-item",
        }, ...children_36);
    }, sortBy((ticket_2) => ticket_2.Datum, verrechnung.Tickets, {
        Compare: compare,
    })), append_1([Icons_TicketErstellenLink((_arg_3) => {
        navigateTo(new Page_2(3, [ticketText(verrechnung), verrechnung.RechnungId]));
    })], array_8))), react.createElement("div", {
        className: "ticket-list is-hidden-desktop data-list",
    }, ...children_38))], react.createElement("table", {
        className: "table table-striped responsive-table is-hidden-touch tickets",
    }, ...children_40)), (children_50 = reverse((array_13 = map((ticket_5) => {
        let children_46, children_44;
        const children_48 = [react.createElement("p", {}, ticket_5.Betreff), (children_46 = [asString(ticket_5.Datum), " - ", ticket_5.IstErledigt ? (ticket_5.HatAntworten ? "Beantwortet" : "Erledigt") : "In Arbeit", (children_44 = [Icons_TicketLink("Anzeigen", (_arg_4) => {
            navigateTo(new Page_2(1, [ticket_5.TicketId]));
        })], react.createElement("span", {
            className: "go-to-ticket",
        }, ...children_44))], react.createElement("p", {}, ...children_46))];
        return react.createElement("div", {
            className: "ticket",
        }, ...children_48);
    }, sortBy((ticket_4) => ticket_4.Datum, verrechnung.Tickets, {
        Compare: compare,
    })), append_1([Icons_TicketErstellenLink((_arg_5) => {
        navigateTo(new Page_2(3, [ticketText(verrechnung), verrechnung.RechnungId]));
    })], array_13))), react.createElement("div", {
        className: "ticket-list is-hidden-desktop",
    }, ...children_50))]), singleton(react.createElement("button", {
        className: "button ",
        onClick: (_arg_6) => {
            dispatch(new Msg(17, [undefined]));
        },
    }, "Schließen")));
}

export function view(model, dispatch, navigateTo) {
    const children = toList(delay(() => append(model.ShowInfoBox ? singleton_1(infoBox(dispatch, navigateTo)) : empty(), delay(() => {
        let matchValue, testExpr, testExpr_1;
        return append((matchValue = model.Filialen, (matchValue.tag === 1) ? singleton_1(spinner) : ((matchValue.tag === 2) ? singleton_1(errorMsg(matchValue.fields[0])) : ((matchValue.tag === 3) ? (((testExpr = matchValue.fields[0], !equalsWith(equals, testExpr, defaultOf()) && (testExpr.length === 0))) ? (empty()) : (((testExpr_1 = matchValue.fields[0], !equalsWith(equals, testExpr_1, defaultOf()) && (testExpr_1.length === 1))) ? (empty()) : append(singleton_1(filialenRow(model.SelectedFilialeId, dispatch, matchValue.fields[0])), delay(() => singleton_1(filialenMobile(model.SelectedFilialeId, dispatch, matchValue.fields[0])))))) : singleton_1(spinner)))), delay(() => {
            let matchValue_1, testExpr_2;
            return append((matchValue_1 = model.Verrechnungen, (matchValue_1.tag === 3) ? (((testExpr_2 = matchValue_1.fields[0], !equalsWith(equals, testExpr_2, defaultOf()) && (testExpr_2.length === 0))) ? singleton_1(emptyBox) : singleton_1(monatBoxen(dispatch, navigateTo, matchValue_1.fields[0], model))) : ((matchValue_1.tag === 1) ? singleton_1(spinner) : ((matchValue_1.tag === 2) ? singleton_1(errorMsg(matchValue_1.fields[0])) : singleton_1(emptyBox)))), delay(() => append(singleton_1(dtaReportText(dispatch, (arg) => {
                navigateTo(arg);
            }, model)), delay(() => ((model.ShowTicketModalFor != null) ? singleton_1(ticketModal(value_2(model.ShowTicketModalFor), (arg_1) => {
                navigateTo(arg_1);
            }, dispatch)) : empty())))));
        }));
    }))));
    return react.createElement("div", {
        className: "verrechnungen-container",
    }, ...children);
}

//# sourceMappingURL=View.fs.js.map
